import React, { useEffect, useRef, useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import { clearFAQDetails } from "./faqSlice";
import {
  createFAQ,
  getAllFAQ,
  getFAQByID,
  updateFAQ,
} from "./services/faq.services";

import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { STATUSARRAY } from "../../_contstants/common";
import FormTextArea from "../../components/formFields/FormTextArea";
import { closed } from "../../components/drawer/drawerSlice";
import IconButton from "../../components/common/IconButton";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";

const CreateFAQ: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  const FAQDetail = useAppSelector((state) => state.faq.FAQDetail);
  const FAQID = useAppSelector((state) => state.drawer.data);

  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [FAQDetail]);

  const formloading = useAppSelector((state) => state.faq.formloading);

  useEffect(() => {
    return () => {
      dispatch(clearFAQDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (FAQID) {
      dispatch(getFAQByID(FAQID));
    }
  }, [FAQID]);

  const handleSubmit = async (values: any) => {
    try {
      if (!FAQID) {
        const insertPayload = {
          Answer: values?.Answer ? values?.Answer : "",
          Question: values?.Question ? values?.Question : "",
          SequenceNo: values.SequenceNo ? +values.SequenceNo : null,
          IsActive: values.IsActive === 1,
        };
        const response = await dispatch(createFAQ(insertPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearFAQDetails());
          dispatch(getAllFAQ());
        }
      } else {
        const editPayload = {
          ID: FAQID,
          Answer: values?.Answer ? values?.Answer : "",
          Question: values?.Question ? values?.Question : "",
          SequenceNo: values.SequenceNo ? +values.SequenceNo : null,
          IsActive: values.IsActive === 1,
        };
        const response = await dispatch(updateFAQ(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearFAQDetails());
          dispatch(getAllFAQ());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
    dispatch(clearFAQDetails());
  };

  // if (formloading) return <LoadingPanel gridRef={gridRef} />;

  return (
    <>
      {formloading && <LoadingPanel gridRef={gridRef} />}
      <Form
        onSubmit={handleSubmit}
        initialValues={FAQDetail}
        key={formKey}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement style={{ width: "100%" }}>
            <GridLayout gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
              <GridLayoutItem
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: 20,
                }}
              >
                <Typography.h4 className="m-0">
                  {FAQID ? "Update FAQ" : "Add FAQ"}
                </Typography.h4>

                <IconButton
                  type="button"
                  fillMode={"flat"}
                  themeColor={"dark"}
                  style={{ marginRight: 4 }}
                  onClick={() => dispatch(closed())}
                  icon={RxCross1}
                />
              </GridLayoutItem>
              <GridLayoutItem>
                <Field
                  name="Question"
                  label="Question"
                  placeholder="Question"
                  component={FormTextArea}
                  astrike={true}
                  validator={requiredValidator}
                />
              </GridLayoutItem>
              <GridLayoutItem>
                <Field
                  name="Answer"
                  label="Answer"
                  placeholder="Answer"
                  component={FormTextArea}
                  validator={requiredValidator}
                  astrike={true}
                />
              </GridLayoutItem>
              <GridLayoutItem>
                <Field
                  wrapperClassName="right-aligned-field"
                  name="SequenceNo"
                  label="Sequence No."
                  placeholder="0"
                  format="n0"
                  component={FormNumericTextField}
                  validator={requiredValidator}
                  astrike={true}
                />
              </GridLayoutItem>

              <GridLayoutItem>
                <Field
                  id={"IsActive"}
                  name={"IsActive"}
                  label={"Status"}
                  placeholder="i.e. Active"
                  component={FormSelectionField}
                  validator={requiredValidator}
                  astrike={true}
                  options={STATUSARRAY?.map((status: any) => {
                    return {
                      value: status.value,
                      label: status.label,
                    };
                  })}
                />
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <ButtonWithLoading
                  label={FAQID ? "Update" : "Save"}
                  type="submit"
                  disabled={!formRenderProps.allowSubmit || formloading}
                  loading={formloading}
                />

                <Button
                  type="button"
                  fillMode={"outline"}
                  themeColor={"primary"}
                  style={{ marginLeft: 10 }}
                  onClick={handleFormClose}
                >
                  Cancel
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateFAQ;
